/**
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Castiel
 * Created: 28/09/23
 */

import { WithCurrentAssignmentProps } from '@/components/contexts/AssignmentContext/withCurrentAssignment';
import WorkplanSummaryProvider from '@/components/contexts/WorkplanSummaryContext/WorkplanSummaryProvider';

import { WorkplanAllocationsTile } from '@/components/pages/dashboard/tiles';
import ItemsTile from '@/components/pages/dashboard/tiles/ItemsTile/ItemsTile';
import WorkplanLeaveTile from '@/components/pages/dashboard/tiles/LeaveTile/WorkplanLeaveTile';
import { Grid, GridItem } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import ButtonActionTile from './tiles/ButtonTile/ButtonActionTile';
import WorkplanSupervisorsTile from '@/components/pages/dashboard/tiles/SupervisorTile/WorkplanSupervisorsTile';
import { DashboardHeaderTile } from '@/components/Header/DashboardHeaderTile';
import ReviewTile from '@/components/pages/dashboard/tiles/ReviewTile/ReviewTile';
import { MySummaryHeading } from '@/components/pages/dashboard/MySummaryHeading';
import WorkplanEOYRatingTile from '@/components/pages/dashboard/tiles/WorkplanEOYRatingTile/WorkplanEOYRatingTile';
import { useWorkplan } from '@/components/contexts/WorkplanContext/useWorkplan';
import { useNavigate } from 'react-router-dom';

const DashboardContent = ({ currentAssignment }: WithCurrentAssignmentProps) => {
    const { workplan } = useWorkplan();
    const navigate = useNavigate();

    useEffect(() => {
        /* If the workplan is from another assignment, redirect to dashboard as the current assignment
         * will not have privilege to edit workplan. This occurs if the workplan ID is in the URL path
         * and navigating back to that URL. */
        if (workplan && workplan.assignment?.id !== currentAssignment.id) {
            navigate('/');
        }
    }, [workplan, currentAssignment]);

    return (
        <WorkplanSummaryProvider>
            <Grid w={'100%'} templateColumns={'repeat(2, 1fr)'} gap={6} p={6}>
                <DashboardHeaderTile heading />
                <GridItem colSpan={2}>
                    <MySummaryHeading />
                </GridItem>
                <GridItem colSpan={{ base: 2, lg: 1 }}>
                    <Grid gap={6} templateRows={'0.5fr 1.5fr'} h={'100%'}>
                        <WorkplanSupervisorsTile />
                        <WorkplanLeaveTile />
                    </Grid>
                </GridItem>
                <WorkplanAllocationsTile />
                <ItemsTile />
                <WorkplanEOYRatingTile assignment={currentAssignment} />
                <ReviewTile assignment={currentAssignment} />
                <ButtonActionTile assignment={currentAssignment} />
            </Grid>
        </WorkplanSummaryProvider>
    );
};

export default DashboardContent;
